export default "__VITE_ASSET__vFI1oCua__"